/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { SupplierExceptionDto } from '../../models/supplier-exception-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface SaveNewSupplierException$Params {
  body: SupplierExceptionDto;
}

export function saveNewSupplierException(
  http: HttpClient,
  rootUrl: string,
  params: SaveNewSupplierException$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SupplierExceptionDto>> {
  const rb = new RequestBuilder(rootUrl, saveNewSupplierException.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupplierExceptionDto>;
    }),
  );
}

saveNewSupplierException.PATH = '/service/v1/supplierExceptions';
